import { Box, Grid } from '@mui/material';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import './app.css';
import { Footer } from './common/footer';
import { Header } from './common/header';
import { Menu } from './common/menu';
import { AboutPage } from './pages/aboutPage';
import { CloudPage } from './pages/cloudPage';
import { ContactPage } from './pages/contactPage';
import { HomePage } from './pages/homePage';
import { IntegrationsPage } from './pages/integrationsPage';
import { MonitoringPage } from './pages/monitoringPage';
import { PortfolioPage } from './pages/portfolioPage';
import { ProcessPage } from './pages/processPage';
import { ResumePage } from './pages/resumePage';
import { ComfortPage } from './pages/smarthome/comfortPage';
import { EfficiencyPage } from './pages/smarthome/efficiencyPage';
import { HealthPage } from './pages/smarthome/healthPage';
import { SafetyPage } from './pages/smarthome/safetyPage';
import { SmartHomePage } from './pages/smarthome/smartHomePage';
import { ToolsPage } from './pages/toolsPage';
import { TrackingPage } from './pages/trackingPage';
import { WebAppPage } from './pages/webAppPage';
import { BlogListPage } from './pages/blog/blogListPage';
import { BlogDetailPage } from './pages/blog/blogDetailPage';
import { BlogEditorPage } from './pages/blog/blogEditorPage';
import { BlogAdminPage } from './pages/blog/blogAdminPage';
import { TipOfTheDayPage } from './pages/tips/tipOfTheDayPage';
import { TipsAdminPage } from './pages/tips/tipsAdminPage';
import { TipEditorPage } from './pages/tips/tipEditorPage';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PrivacyPage } from './pages/privacyPage';
import { TermsPage } from './pages/termsPage';
import { ServicesAdminPage } from './pages/services/servicesAdminPage';
import { ServiceEditorPage } from './pages/services/serviceEditorPage';
import { EventsAdminPage } from './pages/events/eventsAdminPage';
import { EventEditorPage } from './pages/events/eventEditorPage';
import { EventRegistrantsPage } from './pages/events/eventRegistrantsPage';
import { OrdersAdminPage } from './pages/orders/ordersAdminPage';

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);
  return null;
}

export function App() {
  return (
    <>
      <BrowserRouter>
        <RouteTracker />
        <Header />
        <Menu />
        <Box className='mainContent'>
          <Grid container spacing={2}>
            <Grid item xs={1} />

            <Grid item xs={10}>
              <ProtectedRoute>
                <Routes>
                  <Route path='/' element={<HomePage />} />
                  <Route path='/home' element={<HomePage />} />
                  <Route path='/about' element={<AboutPage />} />
                  <Route path='/portfolio' element={<PortfolioPage />} />
                  <Route path='/process' element={<ProcessPage />} />
                  <Route path='/contact' element={<ContactPage />} />
                  <Route path='/resume' element={<ResumePage />} />
                  <Route path='/cloud' element={<CloudPage />} />
                  <Route path='/integrations' element={<IntegrationsPage />} />
                  <Route path='/monitoring' element={<MonitoringPage />} />
                  <Route path='/tools' element={<ToolsPage />} />
                  <Route path='/tracking' element={<TrackingPage />} />
                  <Route path='/webApp' element={<WebAppPage />} />
                  <Route path='/smartHome' element={<SmartHomePage />} />
                  <Route path='/smartHome/comfort' element={<ComfortPage />} />
                  <Route path='/smartHome/efficiency' element={<EfficiencyPage />} />
                  <Route path='/smartHome/safety' element={<SafetyPage />} />
                  <Route path='/smartHome/health' element={<HealthPage />} />
                  <Route path='/blog' element={<BlogListPage />} />
                  <Route path='/blog/:id' element={<BlogDetailPage />} />
                  <Route path='/privacy' element={<PrivacyPage />} />
                  <Route path='/terms' element={<TermsPage />} />
                  <Route path='/blog/admin' element={<BlogAdminPage />} />
                  <Route path='/blog/new' element={<BlogEditorPage />} />
                  <Route path='/blog/:id/edit' element={<BlogEditorPage />} />
                  <Route path='/tips' element={<TipOfTheDayPage />} />
                  <Route path='/tips/admin' element={<TipsAdminPage />} />
                  <Route path='/tips/new' element={<TipEditorPage />} />
                  <Route path='/tips/:id/edit' element={<TipEditorPage />} />
                  <Route path='/services/admin' element={<ServicesAdminPage />} />
                  <Route path='/services/new' element={<ServiceEditorPage />} />
                  <Route path='/services/:id/edit' element={<ServiceEditorPage />} />
                  <Route path='/events/admin' element={<EventsAdminPage />} />
                  <Route path='/events/new' element={<EventEditorPage />} />
                  <Route path='/events/:id/edit' element={<EventEditorPage />} />
                  <Route path='/events/:id/registrants' element={<EventRegistrantsPage />} />
                  <Route path='/orders/admin' element={<OrdersAdminPage />} />
                </Routes>
              </ProtectedRoute>
            </Grid>

            <Grid item xs={1} />
          </Grid>
        </Box>
        <Footer />
      </BrowserRouter>
    </>
  );
}
